// extracted by mini-css-extract-plugin
export var pillWrapper = "_o1-0";
export var showOverflow = "_o1-1";